export default __webpack_public_path__ + "static/media/SWT1460.34I-35763_-20862_0.73fad970.jpg";